var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"data-svg-lvl-2":"edge-top","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 514 430"}},[_c('PreviewLayersEdgeTopSliceM4',{attrs:{"params":_vm.params}}),(_vm.params.flapComponent)?_c(`PreviewLayersEdgeTopFlapF${_vm.params.flapComponent}`,{tag:"component",attrs:{"params":_vm.params}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }